
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.75 12H9V7.853h-.75M9 6h.008m6.742 3a6.75 6.75 0 11-13.5 0 6.75 6.75 0 0113.5 0z","stroke":"gray","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    